module.exports = __webpack_public_path__ + "static/media/silence_20s.3fc4d707.mp3";